<div class="impressum">
    <h2 class="mat-display-2">Impressum</h2>

    <div class="content-page">
        <div>
            <p>
                Informationspflicht laut § 5 DDG. <br>
                Verbund der sozial-kulturellen Migrantenvereine in Dortmund e.V. (VMDO e.V.)
            </p>
            <ul>
                <span>Vertreten durch den Vorstand</span>
                <li>Tülin Dolutas</li>
            </ul>
            <ul>
                <span>Stellvertretende Vorstandsvorsitzende</span>
                <li>Dr. Omar Al Ghawi</li>
                <li>Vedat Akkaya</li>
            </ul>
        </div>

        <h2 class="mat-display-1">Kontakt</h2>
        <div>
            <ul>
                Adresse:
                <!-- <li>Bildungswerk vielfalt</li> -->
                <li>Bildungswerk Vielfalt/VMDO e. V.</li>
                <li class="map">Zur Vielfalt 21, 44147 Dortmund</li>
                <!-- (click)="openDialog()" -->
                <li>Telefon: <a href="tel:+49 231 28678240">+49 231 28678240</a></li>
                <li>Fax: <a href="tel:+49 231 28678166">+49 231 28678166</a></li>
                <li>Email: <a href="mailto:bildungswerk-vielfalt@vmdo.de">bildungswerk-vielfalt@vmdo.de</a></li>
            </ul>
        </div>
        
        <div>
            <h2 class="mat-display-1">Registrierung</h2>
            <p>Eingetragen im Amtsgericht Dortmund VR 6233</p>

            <ul>
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV / V.i.S.d.P.:
                <li>Prof. Dr. Ümit Kosan</li>
                <li class="map">Zur Vielfalt 21, 44147 Dortmund</li>
                <!-- (click)="openDialog()" -->
            </ul>

            <ul>
                Leitung des Bildungswerks:
                <li>Kati Stüdemann</li>
                <li class="map">Zur Vielfalt 21, 44147 Dortmund</li>
                <!-- (click)="openDialog()" -->
            </ul>

            <ul>
                Datenschutzbeauftragter:
                <li>Christoph Boldt</li>
                <li>Poststraße 8, 44137 Dortmund, c.boldt@vmdo.de</li>
            </ul>

            <ul>
                <li>Tel.: <a href="tel:+49 231 / 286-78-350">+49 231 / 286-78-350</a></li>
                <li>Fax: <a href="tel:+49 231 / 286-78-349">+49 231 / 286-78-349</a></li>
                <li>E-Mail: <a href="mailto:info@gid-do.de">info@gid-do.de</a></li>
            </ul>
        </div>

        <div>
            <h2 class="mat-display-1">Aufsichtsbehörde</h2>
            <p>Die Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen</p>
        </div>

        <div>
            <h2 class="mat-display-1">Webseite der Aufsichtsbehörde</h2>
            <p><a href="http://www.ldi.nrw.de" target="_blank">http://www.ldi.nrw.de</a></p>
        </div>

        <div>
            <h2 class="mat-display-1">Anschrift der Aufsichtsbehörde</h2>
            <p>Kavalleriestraße 2-4, 40213 Düsseldorf</p>
        </div>
        
        <div>
            <h2 class="mat-display-1">Geschäftsführerin</h2>
            <p>Sofija Morina</p>
            <p>Berufsbezeichnung: Diplom Sozialpädagogin</p>
            <p>
                Quelle: Erstellt mit dem Impressum Generator von AdSimple in Kooperation mit hashtagbeauty.de
            </p>
        </div>

        <div>
            <h2 class="mat-display-1">EU-Streitschlichtung</h2>
            <p>
                Gemäß Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über die Online-Streitbeilegungsplattform (OS-Plattform) informieren.
                Verbraucher haben die Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der Europäischen Kommission unter http://ec.europa.eu/odr?tid=321118751 zu richten. Die dafür notwendigen Kontaktdaten finden Sie oberhalb in unserem Impressum.

                Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder verpflichtet sind, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
        </div>

        <div>
            <h2 class="mat-display-1">Haftung für Inhalte dieser Website</h2>
            <p>
                Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen uns korrekte und aktuelle Informationen bereitzustellen. Laut Digitale-Dienste-Gesetz (DDG) §7 (1) sind wir als Diensteanbieter für eigene Informationen, die wir zur Nutzung bereitstellen, nach den allgemeinen Gesetzen verantwortlich. Leider können wir keine Haftung für die Korrektheit aller Inhalte auf dieser Webseite übernehmen, speziell für jene die seitens Dritter bereitgestellt wurden. Als Diensteanbieter im Sinne der §§ 8 bis 10 sind wir nicht verpflichtet, die von ihnen übermittelten oder gespeicherten Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p>
                Unsere Verpflichtungen zur Entfernung von Informationen oder zur Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen aufgrund von gerichtlichen oder behördlichen Anordnungen bleiben auch im Falle unserer Nichtverantwortlichkeit nach den §§ 8 bis 10 unberührt.
            </p>
            <p>
                Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte wir Sie uns umgehend zu kontaktieren, damit wir die rechtswidrigen Inhalte entfernen können. Sie finden die Kontaktdaten im Impressum.
            </p>
        </div>

        <div>
            <h2 class="mat-display-1">Haftung für Links auf dieser Website</h2>
            <p>
                Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir nicht verantwortlich sind. Haftung für verlinkte Websites besteht für uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten bekannt werden.
            </p>
            <p>
                Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir Sie uns zu kontaktieren. Sie finden die Kontaktdaten im Impressum.
            </p>
        </div>

        <div>
            <h2 class="mat-display-1">Urheberrechtshinweis</h2>
            <p>
                Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen dem Urheberrecht der Bundesrepublik Deutschland. Bitte fragen Sie uns bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder verwerten wie zum Beispiel auf anderen Websites erneut veröffentlichen. Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der Inhalte unserer Seite rechtlich verfolgen.
            </p>
            <p>
                Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht verletzen, bitten wir Sie uns zu kontaktieren.
            </p>
        </div>

        <div>
            <h2 class="mat-display-1">Bildernachweis</h2>
            <p>
                Die Bilder, Fotos und Grafiken auf dieser Webseite sind urheberrechtlich geschützt.
            </p>
            <p>
                Die Bilderrechte liegen bei den folgenden Fotografen und Unternehmen.
            </p>
            <ul>
                Bilder Landingpage:
                <li><span>Programm</span>: Bild 1 BWV; Bild 2 Denis Treu</li>
                <li><span>Lernplattform</span>: Bild 1 Denis Treu; Bild 2 BWV</li>
                <li><span>Bildungsberatung</span>: Bild 1 & 2 Denis Treu</li>
                <li><span>Projekte</span>: Bild 1 & 2 Denis Treu; Bild 3 Mickaelle Ayossa</li>
                <li><span>Toolbox</span>: Bild 1 & 2 Denis Treu</li>
            </ul>
        </div>
    </div>
</div>